// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__N9app","copyIcon":"styles_copyIcon__om6Rk"};